import { render, staticRenderFns } from "./BlogPostCommemorativeDate.vue?vue&type=template&id=2c6a19a2&scoped=true&"
import script from "./BlogPostCommemorativeDate.vue?vue&type=script&lang=ts&"
export * from "./BlogPostCommemorativeDate.vue?vue&type=script&lang=ts&"
import style0 from "./BlogPostCommemorativeDate.vue?vue&type=style&index=0&id=2c6a19a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a19a2",
  null
  
)

export default component.exports